(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3297],{

/***/ 15102:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-watch/smart-tv",
      function () {
        return __webpack_require__(27431);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 61602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3245);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17651);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62044);
/* harmony import */ var enums__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39933);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22135);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56168);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77838);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70082);










var resizeTimer;
var DeviceList = function(param) {
    var _activeIndex = param.activeIndex, activeIndex = _activeIndex === void 0 ? 0 : _activeIndex;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(enums__WEBPACK_IMPORTED_MODULE_5__/* .Namespace.HowToWatch */ .lS.HowToWatch).t;
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_8__/* .useLang */ .J)().locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(false), rendered = ref[0], setRendered = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), customClass = ref1[0], setCustomClass = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(1024), windowWidth = ref2[0], setWindowWidth = ref2[1];
    var refSwiper = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    var refList = (0,react__WEBPACK_IMPORTED_MODULE_7__.useRef)(null);
    (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useHowToItems */ .e5)(refSwiper, rendered, activeIndex, windowWidth);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        setRendered(true);
        setWindowWidth(window === null || window === void 0 ? void 0 : window.innerWidth);
        window.addEventListener("resize", function() {
            window.clearTimeout(resizeTimer);
            resizeTimer = window.setTimeout(function() {
                setWindowWidth(window === null || window === void 0 ? void 0 : window.innerWidth);
            }, 50);
        });
        var mouseMove = function(e) {
            if (refList.current) {
                var ref = refList.current.getBoundingClientRect(), width = ref.width, height = ref.height, x = ref.x, y = ref.y;
                if (!(x < e.clientX && x + width > e.clientX && y < e.clientY && y + height > e.clientY)) {
                    setCustomClass((_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mouseOut));
                }
                window.addEventListener("mousemove", mouseMove, false);
            }
        };
        window.addEventListener("mousemove", mouseMove, false);
    }, []);
    var onMouseOut = function(e) {
        e.preventDefault();
        setCustomClass((_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mouseOut));
    };
    var onMouseEnter = function(e) {
        e.preventDefault();
        setCustomClass(null);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("swiper-container"),
            ref: refSwiper,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("swiper-wrapper", (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().list), customClass),
                onMouseOut: onMouseOut,
                onMouseEnter: onMouseEnter,
                ref: refList,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().web), "swiper-slide", activeIndex === 0 && (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().active)),
                        title: t("web.title"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            href: helpers__WEBPACK_IMPORTED_MODULE_3__/* .Permalink.howToWatchWeb */ .xm.howToWatchWeb(locale),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("web.title")
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().smartTV), "swiper-slide", activeIndex === 1 && (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().active)),
                        title: t("smart_tv.title"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            href: helpers__WEBPACK_IMPORTED_MODULE_3__/* .Permalink.howToWatchSmartTV */ .xm.howToWatchSmartTV(locale),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("smart_tv.title")
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().mobile), "swiper-slide", activeIndex === 2 && (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().active)),
                        title: t("mobile.title"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            href: helpers__WEBPACK_IMPORTED_MODULE_3__/* .Permalink.howToWatchMobile */ .xm.howToWatchMobile(locale),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("mobile.title")
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().stream), "swiper-slide", activeIndex === 3 && (_index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().active)),
                        title: t("streaming.title"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                            href: helpers__WEBPACK_IMPORTED_MODULE_3__/* .Permalink.HowToWatchStreaming */ .xm.HowToWatchStreaming(locale),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: t("streaming.title")
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_7__.memo)(DeviceList));


/***/ }),

/***/ 27431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50744);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3245);
/* harmony import */ var components_DeviceList__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61602);
/* harmony import */ var components_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46323);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52662);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70082);
/* harmony import */ var enums__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39933);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17651);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(62044);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20266);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(48762);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_12__);













var HowToWatchSmartTV = function(param) {
    var countryCode = param.countryCode;
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(enums__WEBPACK_IMPORTED_MODULE_7__/* .Namespace.HowToWatch */ .lS.HowToWatch).t;
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_6__/* .useLang */ .J)().locale;
    var user = (0,context__WEBPACK_IMPORTED_MODULE_5__/* .useAuth */ .aC)().user;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_10___default()), {
                children: (0,helpers__WEBPACK_IMPORTED_MODULE_8__/* .basicSEO */ .Fi)(t("seo:how_to_watch_tv_title"), t((0,helpers__WEBPACK_IMPORTED_MODULE_8__/* .getNoTrialTranslationKeyIfNeeded */ .jU)("seo:how_to_watch_tv_description", countryCode)))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().container), (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default()["smart-tv"])),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: t("title")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_DeviceList__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        activeIndex: 1
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_11___default().blocks),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().samsung),
                                        children: t("smart_tv.samsung_title")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("smart_tv.samsung_description")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        href: helpers__WEBPACK_IMPORTED_MODULE_8__/* .Permalink.howToWatchSmartTVSamsung */ .xm.howToWatchSmartTVSamsung(locale),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("btn", "btn-primary"),
                                            children: t("smart_tv.button")
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_12___default().lg),
                                        children: t("smart_tv.lg_title")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: t("smart_tv.lg_description")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_AppLink_AppLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        href: helpers__WEBPACK_IMPORTED_MODULE_8__/* .Permalink.howToWatchSmartTVLG */ .xm.howToWatchSmartTVLG(locale),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("btn", "btn-primary"),
                                            children: t("smart_tv.button")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (HowToWatchSmartTV);


/***/ }),

/***/ 77838:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"DeviceList_container__DiZsV","list":"DeviceList_list__geRY0","mouseOut":"DeviceList_mouseOut__ju7sa","active":"DeviceList_active__Gmn2O","web":"DeviceList_web__IWqc2","smartTV":"DeviceList_smartTV__P8dAT","mobile":"DeviceList_mobile__vBl4m","stream":"DeviceList_stream__WCerY","enlarge":"DeviceList_enlarge__wTgbN","enlargeAndShift":"DeviceList_enlargeAndShift__eyn0Q","grow":"DeviceList_grow__GUe4T","rotate":"DeviceList_rotate__oGOEC","slide-down":"DeviceList_slide-down__kNy7M","slide-up":"DeviceList_slide-up__dzJe_","progressShow":"DeviceList_progressShow__L2SCI","pulsate":"DeviceList_pulsate__6L9TF","fromHalfOpacityToFull":"DeviceList_fromHalfOpacityToFull__PhdiA"};

/***/ }),

/***/ 20266:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"how-to-watch_container__dvQzX","blocks":"how-to-watch_blocks__hU6_4"};

/***/ }),

/***/ 48762:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"smart-tv":"smart-tv_smart-tv__xU7we","samsung":"smart-tv_samsung__wjMzh","lg":"smart-tv_lg__YnJWA"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(15102); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);